import React, { useEffect, useState } from "react";
import axios              from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import useTranslations    from "../../hooks/useTranslations";
import useUserLanguage    from "../../hooks/useUserLanguage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

export default function InstitutionStatEdit() {
  const { id }            = useParams();          // /institution-stats/edit/:id
  const lang              = useUserLanguage();
  const { translations }  = useTranslations(lang);
  const t = (k,d)=> translations[k] || d;

  const [instList,setInst]     = useState([]);
  const [instId,  setId]       = useState("");
  const [students,setStu]      = useState("");
  const [tests,   setTest]     = useState("");
  const [loading, setLoad]     = useState(false);
  const navigate               = useNavigate();

  /* kurumlar + mevcut değer */
  useEffect(()=>{
    (async ()=>{
      try{
        const token = localStorage.getItem("admin_token");

        /* kurumlar */
        const instRes = await axios.get("/api/institution/list",{
          headers:{Authorization:`Bearer ${token}`}
        });
        setInst(instRes.data);

        /* mevcut kayıt */
        const { data } = await axios.get(`/api/stats/${id}`,{
          headers:{Authorization:`Bearer ${token}`}
        });
        setId(data.institution_id);
        setStu(data.student_count);
        setTest(data.test_count);
      }catch(err){
        toast.error(err.response?.data?.error || "Hata");
        navigate(-1);
      }
    })();
  },[id]);

  const handleSave = async e=>{
    e.preventDefault();
    try{
      setLoad(true);
      const token = localStorage.getItem("admin_token");
      await axios.put(`/api/stats/${id}`,
        {
          institution_id:instId, 
          student_count :Number(students)||0,
          test_count    :Number(tests)||0
        },
        { headers:{ Authorization:`Bearer ${token}` }}
      );
      toast.success("Kayıt başarıyla göncellendi!");
                          setTimeout(() => {
                            navigate(`/stat/table`); 
                          }, 1000);
    }catch(err){
      toast.error(err.response?.data?.error||"Hata");
    }finally{ setLoad(false); }
  };

return (
  <div className="card card-body">
    <ToastContainer />
    <h4 className="mb-4">{t("STAT_EDIT", "Kayıt Düzenle")}</h4>

    <form onSubmit={handleSave} className="d-flex flex-column gap-4">
      
      {/* kurum seçimi */}
      <div>
        <label className="form-label fw-semibold">
          {t("INSTITUTION", "Kurum")}
        </label>
        <Select
          options={instList.map(i => ({ value: i.id, label: i.title }))}
          value={instList
            .map(i => ({ value: i.id, label: i.title }))
            .find(opt => opt.value === instId) || null}
          onChange={(opt) => setId(opt ? opt.value : "")}
          isClearable
          placeholder={t("SELECT", "Seçiniz…")}
          classNamePrefix="react-select"
        />
      </div>

      {/* danışman sayısı */}
      <div>
        <label className="form-label fw-semibold">
          {t("STUDENT_COUNT", "Danışman Sayısı")}
        </label>
        <input
          type="number"
          className="form-control"
          value={students}
          onChange={e => setStu(e.target.value)}
          min="0"
          placeholder={t("ENTER_VALUE", "Değer girin…")}
        />
      </div>

      {/* çözülen test */}
      <div>
        <label className="form-label fw-semibold">
          {t("TEST_COUNT", "Çözülen Test")}
        </label>
        <input
          type="number"
          className="form-control"
          value={tests}
          onChange={e => setTest(e.target.value)}
          min="0"
          placeholder={t("ENTER_VALUE", "Değer girin…")}
        />
      </div>

      {/* kaydet butonu */}
      <div className="d-flex justify-content-center mt-3">
        <button className="btn btn-primary px-5" disabled={loading}>
          {loading ? t("SAVING", "Kaydediliyor…") : t("SAVE", "Kaydet")}
        </button>
      </div>
    </form>
  </div>
);
}
